import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { HiChevronDown } from 'react-icons/hi';
import './Header.css';

const Header: React.FC = () => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const handleDropdownToggle = (dropdown: string) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const location = useLocation();

  const isOnlineTrainingActive = location.pathname.startsWith('/video-training') ||
    location.pathname.startsWith('/system-manuals');

  return (
    <header id="header">      
      <nav id="nav">
        <div className="wrap">
          <ul id="menu-primary" className="menu">
            <li className="menu-item">
              <NavLink to="/" title="Home" className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/live-tech-support" className={({ isActive }) => isActive ? 'active' : ''}>Live Tech Support</NavLink>
            </li>
            <li className="menu-item membership-nav">
              <NavLink to="/membership" className={({ isActive }) => isActive ? 'active' : ''}>Membership</NavLink>
            </li>
            <li className="menu-item forum-nav">
              <a 
                href="https://forum.aeuromotive.com/?_fromLogin=1" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Technical Forum
              </a>
            </li>
            <li className="menu-item dropdown" onMouseLeave={() => setActiveDropdown(null)}>
              <a 
                className={`dropdown-toggle ${isOnlineTrainingActive ? 'active' : ''}`} 
                onClick={() => handleDropdownToggle('online-training')}
                onMouseEnter={() => setActiveDropdown('online-training')}
              >
                Online Training <HiChevronDown className="dropdown-arrow" />
              </a>
              <ul className={`dropdown-menu ${activeDropdown === 'online-training' ? 'show' : ''}`}>
                <li><Link to="/video-training" onClick={() => setActiveDropdown(null)}>Video Training</Link></li>
                <li><Link to="/system-manuals" onClick={() => setActiveDropdown(null)}>Training System Manuals</Link></li>
              </ul>
            </li>
            <li className="menu-item dropdown" onMouseLeave={() => setActiveDropdown(null)}>
              <NavLink 
                to="/shop"
                className={({ isActive }) => `dropdown-toggle ${isActive ? 'active' : ''}`}
                onMouseEnter={() => setActiveDropdown('shop')}
                onClick={() => setActiveDropdown(null)}
              >
                Shop <HiChevronDown className="dropdown-arrow" />
              </NavLink>
              <ul className={`dropdown-menu ${activeDropdown === 'shop' ? 'show' : ''}`}>
                <li><Link to="/membership" onClick={() => setActiveDropdown(null)}>Membership</Link></li>
              </ul>
            </li>
            <li className="menu-item">
              <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
                Contact Us
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>
                About
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;

